import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';

export default function ReactivateDeployment({
  deploymentSubscriptions,
  deployment,
  onReactivateSuccess,
  onReactivateFailure,
}) {
  const handleSuccess = () => {
    onReactivateSuccess();
  };

  const subscriptionCount = deploymentSubscriptions?.length || 0;

  return (
    <Dialog
      open={true}
      onClose={onReactivateFailure}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: { xs: '90%', sm: '500px' },
        },
      }}
    >
      <DialogContent>
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontWeight: 500,
              color: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <ToggleOnIcon />
            Deployment reaktivieren
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
            &quot;{deployment?.title || 'Unbenannt'}&quot;
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography sx={{ mb: 2 }}>
            Möchten Sie dieses Deployment wieder aktivieren?
          </Typography>

          <Alert
            severity="info"
            sx={{
              mx: 'auto',
              mb: 2,
              textAlign: 'left',
              '& .MuiAlert-message': {
                width: '100%',
              },
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 500, mb: 1 }}>
              Bitte beachten Sie:
            </Typography>
            <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
              <li>
                {subscriptionCount}{' '}
                {subscriptionCount === 1 ? 'Benutzer wird' : 'Benutzer werden'}{' '}
                wieder aktiviert
              </li>
              <li>Das Abonnement wird sofort wieder aktiviert</li>
              <li>Die Benutzer erhalten wieder Zugriff auf das Deployment</li>
              <li>Die monatliche Abrechnung wird fortgesetzt</li>
            </ul>
          </Alert>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onReactivateFailure}
          variant="outlined"
          sx={{ minWidth: 100 }}
        >
          Abbrechen
        </Button>
        <Button
          onClick={handleSuccess}
          color="primary"
          variant="contained"
          autoFocus
          sx={{ minWidth: 100 }}
        >
          Reaktivieren
        </Button>
      </DialogActions>
    </Dialog>
  );
}
